import { render, staticRenderFns } from "./forbidden.vue?vue&type=template&id=3429139d&scoped=true"
import script from "./forbidden.vue?vue&type=script&lang=js"
export * from "./forbidden.vue?vue&type=script&lang=js"
import style0 from "./forbidden.vue?vue&type=style&index=0&id=3429139d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3429139d",
  null
  
)

export default component.exports